/**
 * @ngdoc service
 * @name common.service:ItxTranslateSvc
 * @requires common.filter:t
 * @description
 * Translation service helper.
 * Uses the filter {@link common.filter:t} to translate the given key to the current lang.
 *
 * @example
 * <pre>
 * ItxTranslateSvc.translateCms('legacy.edit');
 * output:  Editar
 * </pre>
 **/
(function () {
    'use strict';

    angular.module('itxApp.common').factory('ItxTranslateSvc', ItxTranslateSvc);

    ItxTranslateSvc.$inject = ['$filter', 'CmsConfigSvc'];

    function ItxTranslateSvc($filter, CmsConfigSvc) {
        function translate(key) {
            var traducion = $filter('t')(key, [].slice.call(arguments));
            return traducion;
        }

        function translateCms(key) {
            var traduccion = CmsConfigSvc.getSynchronousTranslation(key, [].slice.call(arguments));
            return traduccion;
        }

        function _translateCmsWithoutParams(key) {
            var traduccion = CmsConfigSvc.getSynchronousTranslation(key);
            return traduccion;
        }

        function _waitTranslations() {
            return CmsConfigSvc.waitTranslations();
        }

        return {
            translate: translate,
            translateCms: translateCms,
            waitTranslations: _waitTranslations,
            translateCmsWithoutParams: _translateCmsWithoutParams
        };
    }
})();
